import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Field } from "formik";
import { Popup, Button } from "semantic-ui-react";

import FormikSemanticInput from "./FormikSemanticInput.jsx";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class FormikConfirmedPasswordInput extends PureComponent {
  static propTypes = {
    required: PropTypes.bool.isRequired
  };

  static defaultProps = {
    required: true
  };

  state = {
    showPassword: false
  };

  togglePasswordVisible = evt => {
    // stop the click bubbling to the wider form
    evt.preventDefault();
    evt.stopPropagation();

    const showPassword = !this.state.showPassword;
    this.setState({ showPassword });
  };

  // -- RENDER -- //

  render() {
    const { required, apiErrors, copy } = this.props;
    const { showPassword } = this.state;

    const copyKey = this.props.copyKey || "forms.confirmed_password_input";

    const showIcon = showPassword ? "eye slash" : "eye";
    const popupContent = showPassword
      ? copy(`${copyKey}.hide`)
      : copy(`${copyKey}.show`);

    const disableShowButton = false;

    return (
      <Fragment>
        <Popup
          trigger={
            <Button
              compact
              icon={showIcon}
              size="mini"
              disabled={disableShowButton}
              className="float-right"
              onClick={this.togglePasswordVisible}
              type="button" // important to prevent enter key press
            />
          }
          content={popupContent}
          position="top right"
          size="mini"
        />
        <Field
          name="password"
          label="Password"
          placeholder="Password"
          type={showPassword ? "type" : "password"}
          required={required}
          apiErrors={apiErrors}
          component={FormikSemanticInput}
        />
        <Field
          name="passwordConfirmation"
          label="Confirm Password"
          placeholder="Password"
          type={showPassword ? "type" : "password"}
          required={required}
          apiErrors={apiErrors}
          component={FormikSemanticInput}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(FormikConfirmedPasswordInput);
